import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

const Caption = styled.div`
  font-size: 11px;
  color: ${colors.darkGrey};
  margin-top: 4px;
  max-width: 100px;
`;

export default Caption;
